import styles from './CheckListOverlayControllerContent.module.scss';

import { MaskTabPanel } from '../../../../mask-tabs';
import { MaskContent } from '../../../components/MaskContent/MaskContent';
import { HistoryTabPanel } from '../../../components/tab-panels/history/HistoryTabPanel';
import { SelectedPositionProvider } from '../../erp/components/tab-panels/positions/components/hooks/use-selected-position';

import { ControllerTabs } from './enums';
import { CheckListOverlayControllerGeneralTabContent } from './tabs-content';

export const CheckListOverlayControllerContent = () => {
  return (
    <MaskContent>
      <MaskTabPanel
        value={ControllerTabs.General}
        className={styles.generalTabContent}
      >
        <SelectedPositionProvider>
          <CheckListOverlayControllerGeneralTabContent />
        </SelectedPositionProvider>
      </MaskTabPanel>

      <MaskTabPanel value={ControllerTabs.History}>
        <HistoryTabPanel />
      </MaskTabPanel>
    </MaskContent>
  );
};
